import { useState, useEffect } from 'react';
import { xsBreak, smBreak, mdBreak, lgBreak } from '../styles/_variables.module.scss';

export default function useMedia(query) {
  const [matchesQuery, _setMatchesQuery] = useState(false);
  const setMatchesQuery = (matchQuery) => _setMatchesQuery(matchQuery?.matches);

  useEffect(() => {
    const matchQuery = window.matchMedia(query);
    setMatchesQuery(matchQuery);
    if (matchQuery.addEventListener) {
      matchQuery.addEventListener('change', setMatchesQuery);
    } else {
      // Fall back for Safari <14 - https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/addListener
      matchQuery.addListener(setMatchesQuery);
    }
    return () => {
      if (matchQuery.removeEventListener) {
        matchQuery.removeEventListener('change', setMatchesQuery);
      } else {
        // Fall back for Safari <14 - https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/addListener
        matchQuery.removeListener(setMatchesQuery);
      }
    };
  }, [query]);

  return matchesQuery;
}

export const useExtraSmallUpBp = () => useMedia(`(min-width: ${xsBreak}px)`);
export const useSmallUpBp = () => useMedia(`(min-width: ${smBreak}px)`);
export const useMediumUpBp = () => useMedia(`(min-width: ${mdBreak}px)`);
export const useLargeUpBp = () => useMedia(`(min-width: ${lgBreak}px)`);
